import { supportAddress } from '~/config';

export const getSupportAddress = () => supportAddress;
